import { render, staticRenderFns } from "./PrivacePolice.vue?vue&type=template&id=26527a00&scoped=true"
import script from "./PrivacePolice.vue?vue&type=script&lang=js"
export * from "./PrivacePolice.vue?vue&type=script&lang=js"
import style0 from "./PrivacePolice.vue?vue&type=style&index=0&id=26527a00&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26527a00",
  null
  
)

export default component.exports